module.exports = __webpack_public_path__ + "static/logo-3801a86b58b159eb74795796bbd2d542.png";